import {
  CreateCardTokenisationRequest,
  ShowCardTokenisationRequest,
  TerminalTokenisationsApi,
} from '@trybeapp/sdk'
import { useMutation, useQuery, useQueryClient, UseQueryOptions } from 'react-query'
import { apiConfiguration } from 'utilities/TrybeApiClient'

const api = new TerminalTokenisationsApi(apiConfiguration)

export const useCreateTokenisationRequest = () => {
  const queryClient = useQueryClient()

  return useMutation(
    (createCardTokenisationRequest: CreateCardTokenisationRequest) => {
      return api.createCardTokenisationRequest({ createCardTokenisationRequest })
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['terminalTokenisations'])
        queryClient.invalidateQueries(['paymentMethods'])
      },
    }
  )
}

export const useTokenisationRequest = (
  paymentId: string,
  options?: UseQueryOptions<ShowCardTokenisationRequest>
) => {
  return useQuery<ShowCardTokenisationRequest>(
    ['terminalTokenisation', paymentId],
    () => api.getCardTokenisationRequest({ paymentId }),
    {
      enabled: !!paymentId,
      refetchInterval: 2000, // Poll every 2 seconds
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      retry: false,
      ...options,
    }
  )
}

export const useCancelTokenisationRequest = () => {
  const queryClient = useQueryClient()

  return useMutation(
    (paymentId: string) => {
      return api.actionCancelCardTokenisationRequest({ paymentId })
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['terminalTokenisations'])
      },
    }
  )
}
